export default __webpack_public_path__ + "static/media/firstSphere.0f6a8575.svg";